/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PropertyPricesFilter { 
    /**
     * The start date of the prices to filter from
     */
    date_from: string;
    /**
     * The end date of the prices to filter to
     */
    date_to: string;
}

